<h2 mat-dialog-title>{{ data.titulo }}</h2>
<iframe #iframe width="99%" height="85%"></iframe>
<div mat-dialog-actions fxLayoutAlign="end">
  <button mat-button mat-dialog-close>Fechar</button>
</div>
